module.exports = __webpack_public_path__ + "images/background/image_thumbnail/3-on-49222a804e850ae9c36b961d95ffef00.jpg";